// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/report-settings/logo?societaId=',
    requestBody: null,
    response: 'binary (image/*)'
  },
  {
    method: 'GET',
    endpoint: '/api/report-settings?societaId=',
    requestBody: null,
    response: '{"success":true,"data":null|{...}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/report-settings?societaId=',
    requestBody: '{"ragioneSociale":"string","partitaIva":"string","indirizzo":"string","footerLegale":"string","mittenteNome":"string","mittenteEmail":"string"}',
    response: '{"success":true,"data":{...}}'
  },
  {
    method: 'POST',
    endpoint: '/api/report-settings/upload-logo',
    requestBody: 'FormData{societaId,file}',
    response: '{"success":true,"logoUrl":"string"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
